<template>
  <div style="background-image: linear-gradient(to right, #AEADAD,#FFFFFF,#AEADAD);">
    <div id="show-overlay"></div>

    <div class="wrapper container-fluid container-lg p-0 m-auto m-xs-0" id="main-layout">
      <!-- Sidebar on the left  -->
      <SideBarStyle1 :items="verticalMenu" :horizontal="horizontal" @toggle="sidebarMini" />
      <!-- TOP Nav Bar -->
      <NavBarStyle1
        title="Dashboard"
        :homeURL="{ name: 'dashboard1.home' }"
        @toggle="sidebarMini"
        :logo="logo"
        :horizontal="horizontal"
        :items="horizontalMenu"
      >
        <template slot="left">
          <div class="d-none d-lg-block">
            <BreadCrumb></BreadCrumb>
          </div>
        </template>
        <template slot="responsiveRight">
          <ul class="navbar-nav ml-auto navbar-list">
            <li class="nav-item nav-icon">
              <!-- <b-button variant="primary" class="mb-0 mr-2" v-b-modal.modal-deposit>
                <a target="_blank" style="color: #ffffff;" >
                  <i class="las la-donate"></i> Nạp USDT
                </a>
              </b-button>
              <b-button variant="primary" class="mb-0 mr-2" v-b-modal.modal-buy-package>
                <a target="_blank" style="color: #ffffff;">
                  <i class="las la-shopping-bag"></i> Mua gói
                </a>
              </b-button> -->
              <contact-button/>
            </li>
          </ul>
        </template>
        <template slot="right">
          <ul class="navbar-list">
            <li>
              <a href="#" class="search-toggle iq-waves-effect d-flex align-items-center">
                <img :src="userProfile" class="img-fluid rounded mr-3" alt="user" />
                <div class="caption">
                  <h6 class="mb-0 line-height">Xin chào, {{authUser.user.fullname}}</h6>
                  <!-- <span class="font-size-12 d-none d-md-block">
                    <span class="badge badge-primary"><b>{{infoUser.credit}}</b> Credit</span> | <span class="badge badge-green"><b>{{infoUser.usdt_balance}}</b> USDT</span>
                  </span> -->
                </div>
              </a>
              <div class="iq-sub-dropdown iq-user-dropdown">
                <div class="iq-card shadow-none m-0">
                  <div class="iq-card-body p-0">
                    <div class="bg-primary p-3">
                      <h5 class="mb-0 text-white line-height">Xin chào, {{authUser.user.fullname}}</h5>
                      <p class="d-block d-lg-none"><span class="badge badge-primary"><b>{{infoUser.credit}}</b> Credit</span> | <span class="badge badge-green"><b>{{infoUser.usdt_balance}}</b> USDT</span></p>
                    </div>
                    <router-link :to="{name: 'profile.edit-profile'}">
                      <a href="#" class="iq-sub-card iq-bg-primary-hover">
                        <div class="media align-items-center">
                          <div class="rounded iq-card-icon iq-bg-primary">
                            <i class="ri-file-user-line"></i>
                          </div>
                          <div class="media-body ml-3">
                            <h6 class="mb-0">Trang cá nhân</h6>
                            <p class="mb-0 font-size-12">Xem và chỉnh sửa thông tin cá nhân</p>
                          </div>
                        </div>
                      </a>
                    </router-link>
                    <div class="d-inline-block w-100 text-center p-3">
                      <a
                        class="iq-bg-danger iq-sign-btn"
                        href="javascript:void(0)"
                        @click="logout"
                        role="button"
                      >
                        Đăng xuất
                        <i class="ri-login-box-line ml-2"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </template>
      </NavBarStyle1>
      <!-- TOP Nav Bar END -->
      <div id="content-page" class="content-page" :class="horizontal ? 'ml-0' : ''">
        <!-- <b-container fluid v-if="authUser.user.feature_lock == 1">
          <b-row>
            <b-col col="12">
              <b-alert show variant="danger">Tài khoản của bạn hiện tạm khóa một số chức năng, vui lòng mua thêm credit</b-alert>
            </b-col>
          </b-row>
        </b-container> -->
        <transition
          name="router-anim"
          :enter-active-class="`animated ${animated.enter}`"
          mode="out-in"
          :leave-active-class="`animated ${animated.exit}`"
        >
          <router-view />
        </transition>
        <FooterStyle1>
          <template v-slot:left>
            <li class="list-inline-item">
              <a href="#">Version {{$store.getters['Setting/versionState']}}</a>
            </li>
          </template>
          <template v-slot:right>
            Copyright © 2019
            <a href="#">123GOM</a> All Rights Reserved.
          </template>
        </FooterStyle1>
      </div>
    </div>
    <deposit-modal modal-id="modal-deposit"/>
    <buy-package-modal modal-id="modal-buy-package"/>
  </div>
</template>
<script>
import SideBarStyle1 from '../components/findash/sidebars/SideBarStyle1'
import NavBarStyle1 from '../components/findash/navbars/NavBarStyle1'
import HorizontalItems from '../FackApi/json/HorizontalMenu'
import profile from '../assets/images/user/user-1.jpeg'
import loader from '../assets/images/loader.gif'
import darkLoader from '../assets/images/darkMode/dark-logo.gif'
import { findash } from '../config/pluginInit'
import { Users } from '../FackApi/api/chat'
import { mapGetters, mapActions } from 'vuex'
import BreadCrumb from '../components/findash/breadcrumbs/BreadCrumb'
import DepositModal from '@/components/application/usdt_transaction/DepositModal'
import BuyPackageModal from '@/components/application/package/BuyPackageModal'
import ContactButton from '@/components/application/misc/ContactButton'

let body = document.querySelector('body')
export default {
  name: 'ApplicationLayout',
  components: {
    ContactButton,
    BuyPackageModal,
    DepositModal,
    // Lottie,
    SideBarStyle1,
    NavBarStyle1,
    BreadCrumb
  },
  mounted () {
    this.updateRadio()
    body.classList.remove('sidebar-main-active')
    body.classList.remove('right-column-fixed')
    if (this.$route.meta.dark) {
      body.classList.add('dark')
      body.classList.remove('light')
      this.logo = darkLoader
    } else {
      body.classList.add('light')
      body.classList.remove('dark')
      this.logo = loader
    }
  },
  computed: {
    ...mapGetters({
      cartCount: 'Ecommerce/cartCountState',
      cartItems: 'Ecommerce/cartState',
      selectedLang: 'Setting/langState',
      langsOptions: 'Setting/langOptionState',
      darkMode: 'Setting/darkModeState',
      colors: 'Setting/colorState',
      authUser: 'Auth/authUserState',
      infoUser: 'Auth/userInfoState'
    })
  },
  watch: {},
  // sidebarTicket
  data () {
    return {
      horizontal: false,
      mini: false,
      animated: { enter: 'fadeIn', exit: 'fadeOut' },
      animateClass: [
        { value: { enter: 'zoomIn', exit: 'zoomOut' }, text: 'Zoom' },
        { value: { enter: 'fadeInUp', exit: 'fadeOutDown' }, text: 'Fade' },
        {
          value: { enter: 'slideInLeft', exit: 'slideOutRight' },
          text: 'Slide'
        },
        {
          value: { enter: 'rotateInDownLeft', exit: 'rotateOutDownLeft' },
          text: 'Roll'
        }
      ],
      horizontalMenu: HorizontalItems,
      verticalMenu: [
        {
          'title': 'Trang chính',
          'name': 'trang_chinh',
          'is_heading': false,
          'is_active': false,
          'link': {
            'name': 'dashboard.home-1'
          },
          'class_name': '',
          'is_icon_class': true,
          'icon': 'las la-home iq-arrow-left'
        },
        {
          'title': 'Kế toán',
          'name': 'ke_toan',
          'is_heading': false,
          'is_active': false,
          'link': '',
          'class_name': '',
          'is_icon_class': true,
          'icon': 'lar la-chart-bar iq-arrow-left',
          'children': [
            {
              'title': 'Kế toán tự động',
              'name': 'ke_toan_tu_dong',
              'is_active': false,
              'link': {
                'name': 'report.auto.http'
              },
              'class_name': '',
              'is_icon_class': true,
              'icon': 'lar la-circle'
            },
            {
              'title': 'Báo cáo',
              'name': 'bao_cao',
              'is_active': false,
              'link': {
                'name': 'report.list'
              },
              'class_name': '',
              'is_icon_class': true,
              'icon': 'lar la-circle'
            }
          ]
        },
        {
          'title': 'Quản lý',
          'name': 'quan_ly',
          'is_heading': false,
          'is_active': false,
          'link': '',
          'class_name': '',
          'is_icon_class': true,
          'icon': 'las la-tools iq-arrow-left',
          'children': [
            // {
            //   'title': 'Liên kết',
            //   'name': 'lien_ket',
            //   'is_active': false,
            //   'link': {
            //     'name': 'manage.link'
            //   },
            //   'class_name': '',
            //   'is_icon_class': true,
            //   'icon': 'lar la-circle'
            // },
            {
              'title': 'Công thức',
              'name': 'cong_thuc',
              'is_active': false,
              'link': {
                'name': 'manage.formular'
              },
              'class_name': '',
              'is_icon_class': true,
              'icon': 'lar la-circle'
            },
            {
              'title': 'Nhóm công thức',
              'name': 'nhom_cong_thuc',
              'is_active': false,
              'link': {
                'name': 'manage.group_formula'
              },
              'class_name': '',
              'is_icon_class': true,
              'icon': 'lar la-circle'
            },
            {
              'title': 'Khách hàng',
              'name': 'khach_hang',
              'is_active': false,
              'link': {
                'name': 'manage.customer'
              },
              'class_name': '',
              'is_icon_class': true,
              'icon': 'lar la-circle'
            },
            {
              'title': 'Tài khoản',
              'name': 'tai_khoan',
              'is_active': false,
              'link': {
                'name': 'manage.account'
              },
              'class_name': '',
              'is_icon_class': true,
              'icon': 'lar la-circle'
            }
          ]
        },
        {
          'title': 'Lịch sử giao dịch',
          'name': 'lich_su_giao_dich',
          'is_heading': false,
          'is_active': false,
          'link': {
            'name': 'transaction-log.list'
          },
          'class_name': '',
          'is_icon_class': true,
          'icon': 'las la-history iq-arrow-left'
        },
        {
          'title': 'Lịch sử hoạt động',
          'name': 'lich_su_hoat_dong',
          'is_heading': false,
          'is_active': false,
          'link': {
            'name': 'activity-log.list'
          },
          'class_name': '',
          'is_icon_class': true,
          'icon': 'las la-history iq-arrow-left'
        },
        {
          'title': 'Ví USDT',
          'name': 'nap_rut',
          'is_heading': false,
          'is_active': false,
          'link': {
            'name': 'deposit-withdraw.add'
          },
          'class_name': '',
          'is_icon_class': true,
          'icon': 'las la-wallet iq-arrow-left'
        },
        {
          'title': 'Thành viên',
          'name': 'thanh_vien',
          'is_heading': false,
          'is_active': false,
          'link': '',
          'class_name': '',
          'is_icon_class': true,
          'icon': 'las la-user-friends iq-arrow-left',
          'children': [
            {
              'title': 'Thêm thành viên',
              'name': 'them_thanh_vien',
              'is_active': false,
              'link': {
                'name': 'user-manage.add'
              },
              'class_name': '',
              'is_icon_class': true,
              'icon': 'lar la-circle'
            },
            {
              'title': 'Danh sách thành viên',
              'name': 'ds_thanh_vien',
              'is_active': false,
              'link': {
                'name': 'user-manage.list'
              },
              'class_name': '',
              'is_icon_class': true,
              'icon': 'lar la-circle'
            }
          ]
        }
      ],
      userProfile: profile,
      logo: loader,
      usersList: Users,
      rtl: false,
      notification: [
        {
          image: require('../assets/images/user/user-01.jpg'),
          name: 'Hết hạn credit',
          date: '1 giờ trước',
          description: 'Số credit gần hết'
        },
        {
          image: require('../assets/images/user/user-01.jpg'),
          name: 'Cập nhật mới',
          date: '7 ngày trước',
          description: 'Hệ thống cập nhật'
        },
        {
          image: require('../assets/images/user/user-01.jpg'),
          name: 'Thay đổi',
          date: '1 giờ trước',
          description: 'Hệ thống update version 1.3'
        }
      ]
    }
  },
  methods: {
    updateRadio () {
      this.horizontal = this.$store.getters['Setting/horizontalMenuState']
      this.mini = this.$store.getters['Setting/miniSidebarState']
    },
    sidebarHorizontal () {
      this.$store.dispatch('Setting/horizontalMenuAction')
      this.updateRadio()
    },
    sidebarMini () {
      findash.triggerSet()
      this.$store.dispatch('Setting/miniSidebarAction')
      this.updateRadio()
    },
    reset () {
      this.changeColor({
        primary: '#827af3',
        primaryLight: '#b47af3',
        bodyBgLight: '#efeefd',
        bodyBgDark: '#1d203f'
      })
      this.animated = { enter: 'zoomIn', exit: 'zoomOut' }
      this.light()
    },
    logout () {
      this.$store.dispatch('Auth/authUserLogout')
    },
    ...mapActions({
      removeToCart: 'Ecommerce/removeToCartAction',
      langChangeState: 'Setting/setLangAction',
      rtlAdd: 'Setting/setRtlAction',
      rtlRemove: 'Setting/removeRtlAction',
      modeChange: 'Setting/darkModeAction'
    })
  }
}
</script>
<style>
@import url("../assets/css/custom.css");
@import url("../assets/css/PriceSlider.css");
</style>
